import {
  container_styles_default
} from "./chunk.USJQKTI6.js";
import {
  content_styles_default
} from "./chunk.SDLSAYZQ.js";
import {
  ApplicationSection
} from "./chunk.3TZLHWFR.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/content/content.ts
var FadvContent = class extends ApplicationSection {
  firstUpdated() {
    super.firstUpdated();
    const app = document.querySelector("fadv-application");
    this.fixed = (app == null ? void 0 : app.hasAttribute("fixed")) || false;
  }
  render() {
    return $`<div class=${o({
      content: true,
      "content--fixed": this.fixed
    })} >${this.renderContainer()}</div>`;
  }
};
FadvContent.styles = [container_styles_default, content_styles_default];
__decorateClass([
  t()
], FadvContent.prototype, "fixed", 2);
FadvContent = __decorateClass([
  n("fadv-content")
], FadvContent);

export {
  FadvContent
};
